(function () {
	'use strict';

	angular
		.module('dcApp')
		.controller(
			'VersionConfigurationModalController',
			VersionConfigurationModalController
		);

	VersionConfigurationModalController.$inject = [
		'ProjectService',
		'ContextServices',
		'toaster',
		'gettextCatalog',
	];

	function VersionConfigurationModalController(
		ProjectService,
		ContextServices,
		toaster,
		gettextCatalog
	) {
		const vm = this;

		vm.contexts = [];
		vm.contextsLoaded = false;
		vm.savingInProgress = false;
		vm.onContextsReady = onContextsReady;
		vm.save = save;

		init();

		function init() {
			ProjectService.getProject(vm.versionId).then(function (response) {
				const project = response.data || {};
				vm.version = project.version;
				vm.versionDescription = project.version_description;
				loadContexts(project.contexts || []);
			});
		}

		/**
		 * Chargement des contextes disponibles puis report de la configuration
		 * déjà enregistrée sur la version.
		 */
		function loadContexts(projectContexts) {
			ContextServices.getContextList(true).then(function (response) {
				vm.contexts = response.data || [];
				for (let c in projectContexts) {
					let ctx = _.find(vm.contexts, function (item) {
						return item.id === projectContexts[c].context_id;
					});
					if (ctx) {
						ctx.jobs = projectContexts[c].jobs;
						ctx.persistence = projectContexts[c].persistence;
					}
				}
				vm.contextsLoaded = true;
			});
		}

		function onContextsReady(api) {
			vm.contextsApi = api;
		}

		function save() {
			const selectedContexts = vm.contextsApi
				? vm.contextsApi.getSelectedContexts()
				: [];
			if (!isValid(selectedContexts)) {
				return;
			}
			vm.savingInProgress = true;
			const configuration = {
				version: vm.version,
				version_description: vm.versionDescription,
				contexts: selectedContexts,
			};
			ProjectService.updateProjectVersionConfiguration(
				vm.versionId,
				configuration
			).then(
				function () {
					toaster.pop(
						'success',
						gettextCatalog.getString('Succès'),
						gettextCatalog.getString('project.version.config.save.success')
					);
					vm.savingInProgress = false;
					vm.$accept(configuration);
				},
				function () {
					toaster.pop(
						'error',
						gettextCatalog.getString('project.version.config.save.error')
					);
					vm.savingInProgress = false;
				}
			);
		}

		/**
		 * Au moins un contexte de persistance et un contexte d'activités.
		 */
		function isValid(selectedContexts) {
			if (
				!_.filter(selectedContexts, function (item) {
					return item.persistence;
				})[0]
			) {
				toaster.pop(
					'error',
					gettextCatalog.getString(
						'Un contexte Persistance/Extraction/Export est obligatoire'
					)
				);
				return false;
			}
			if (
				!_.filter(selectedContexts, function (item) {
					return item.jobs;
				})[0]
			) {
				toaster.pop(
					'error',
					gettextCatalog.getString(
						'Un contexte Autres activités est obligatoire'
					)
				);
				return false;
			}
			return true;
		}
	}
})();
